<template>
  <div>
    <div
      v-if="resultCount >= 0"
      role="status"
      class="store-result storelocator--results storelocater-col-md-12"
    >
      <p v-if="resultCount > 0">
        <span>{{ storeText }}</span> {{ resultCount }} {{ storeValue }} {{ zipcode }}
      </p>
      <p v-else-if="locationStatus">{{ geoError }}</p>
      <p v-else-if="storeList">{{ title }}</p>
    </div>

    <div
      v-if="showToggle && resultCount >= 0"
      class="store-result storelocator--results storelocater-col-md-12"
    >
      <label v-if="filterLabelText != ''" for="map-display" class="stlc-storelocator-filter-label">
        {{ filterLabelText }}
      </label>
      <select
        id="map-display"
        class="storelocator__input input--text storelocater------select"
        @change="toggleOptions($event)"
      >
        <option
          v-for="option in displayFilterOptions"
          :key="option.code"
          :selected="option.code == displayMode"
          :value="option.code"
        >
          {{ option.description }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { DisplayMode } from '../mixins/constants';

export default {
  name: 'rfp-storelocator-summary',
  props: {
    displayFilterOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    displayMode: {
      type: String,
      required: false,
      default: DisplayMode.List,
      validator(value) {
        return Object.values(DisplayMode).includes(value);
      },
    },
    filterLabelText: {
      type: String,
      required: false,
      default: '',
    },
    geoError: {
      type: String,
      required: true,
    },
    storeText: {
      type: String,
      required: true,
    },
    storeValue: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      locationStatus: false,
      resultCount: -1, // list hasn't loaded, positive value or 0 after
      showToggle: false,
      zipcode: '',
    };
  },
  created() {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const syncShowToggleFromViewport = () => {
      this.showToggle = mediaQuery.matches;
    };
    syncShowToggleFromViewport();
    mediaQuery.addEventListener('change', syncShowToggleFromViewport);
    this._summaryMediaQuery = mediaQuery;
    this._summaryMediaQueryHandler = syncShowToggleFromViewport;

    // Display the Geolocation message
    eventBus.on('locationMsg', () => {
      this.locationStatus = true;
    });

    eventBus.on('pagination_record_count', (datas) => {
      this.resultCount = datas.TotalStoreCount;
    });

    eventBus.on('postalCode', (value) => {
      this.zipcode = value;
    });
  },
  beforeDestroy() {
    this._detachSummaryMediaQuery();
  },
  beforeUnmount() {
    this._detachSummaryMediaQuery();
  },
  methods: {
    _detachSummaryMediaQuery() {
      this._summaryMediaQuery?.removeEventListener('change', this._summaryMediaQueryHandler);
    },
    toggleOptions($event) {
      const selectedOption = $event.target.value;

      eventBus.emit('toggleMap', selectedOption !== DisplayMode.List);
      eventBus.emit('toggleStoreList', selectedOption !== DisplayMode.Map);
    },
  },
};
</script>
